import { NgModule, SecurityContext } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule, MarkdownPipe, MarkdownService, MarkedOptions } from 'ngx-markdown';
import { MdRendererComponent } from './components/md-renderer/md-renderer.component';

// Ref: https://github.com/jfcere/ngx-markdown#markedoptions
// Ref: https://marked.js.org/using_advanced#options
@NgModule({
  declarations: [MdRendererComponent],
  imports: [
    CommonModule,
    MarkdownModule.forRoot({
      sanitize: SecurityContext.HTML,
      markedOptions: {
        provide: MarkedOptions,
        useValue: {
          gfm: true,
          breaks: true,
          pedantic: false,
          smartLists: true,
          smartypants: true,
        },
      },
    }),
  ],
  exports: [
    MdRendererComponent
  ],
  providers: [
    MarkdownService,
    MarkdownPipe,
  ]
})
export class MdRendererModule { }
